import { useContext } from "react"
import ReportsContext from "../contexts/ReportsContext"

const useReports = () => {
  const context = useContext(ReportsContext)

  if (!context) throw new Error("context must be use inside provider")

  return context
}

export default useReports
